import type { VariantProps } from "class-variance-authority";
import type { badgeVariants } from "@/components/ui/badge";

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>["variant"]>;

export const TEMPLATE_STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  active: "Active",
  inactive: "Inactive",
};

export const TEMPLATE_STATUS_BADGE_VARIANTS: Record<string, BadgeVariant> = {
  draft: "secondary",
  active: "success",
  inactive: "slate",
};
